import { Component, OnInit, forwardRef, Input, TemplateRef, ElementRef, SkipSelf, Host, Optional, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, AbstractControl, Validators, FormControl } from '@angular/forms';
import { Helper, AppDateAdapter, APP_DATE_FORMATS } from 'src/app/Helper';
import { MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { parse } from 'querystring';



@Component({
  selector: 'input-template',
  templateUrl: './input-template.component.html',
  styleUrls: ['./input-template.component.css'],
  providers: [

    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTemplateComponent),
      multi: true
    },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]

})
export class InputTemplateComponent implements ControlValueAccessor, OnInit {

  propagateChange: any = () => { };
  @Input('value') _value = 0;

  @Input() template: TemplateRef<ElementRef>;
  @Input() formControlName: string;
  @Input() formControl: any;
  @Input() formControlModel: string;
  @Output() formControlModelChange: EventEmitter<boolean> = new EventEmitter<any>()
  @Output() optionDisable = new EventEmitter ()
  
  @Input() label: string = "";
  @Input() required: any;
  @Input() ucwords = true;
  @Input() uppercase = false;
  @Input() type: string = "text";
  @Input() readOnly: boolean = false;
  search = "";
  checkMulti = []
  @Input() options: any = [];
  @Input() optionKey: string;
  @Input() multiple: any = false;
  @Input() maxlength: any = 255;
  @Input() maxDate: any;
  @Input() minDate: any;

  @Output() change = new EventEmitter();
  @Input('searchValues') searchValues = ['title'];
  erros: any;
  public control: AbstractControl;
  d_length = 0;
  d_width = 0;


  constructor(
    @Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer,
    public Helper: Helper) {
    let date = new Date();
    let date2 = new Date();

    if (!this.maxDate) {

      date.setFullYear(date.getFullYear() + 80);
      this.maxDate = date;

    }
    if (!this.minDate) {

      date2.setFullYear(1800);
      this.minDate = date2;

    }
  }
  ucfirst(e) {
    // if (!this.ucwords) {
    //   if (this.uppercase) {
    //     e.target.value = e.target.value.toUpperCase();
    //   }
    //   return 1;
    // }
    // var str = e.target.value;
    // var splitStr = str.toLowerCase().split(' ');
    // for (var i = 0; i < splitStr.length; i++) {
    //   // You do not need to check if i is larger than splitStr length, as your for does that for you
    //   // Assign it back to the array
    //   splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    // }
    // // Directly return the joined string
    // e.target.value = splitStr.join(' ');
    // if (this.uppercase) e.target.value = e.target.value.toUpperCase();
    
    this.change.emit(e);
     
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
  }
  getErrorMessage() {

    return this.Helper.validationErrors(this.control);
  }
  ngOnInit() {

    console.log("this.formControl",this.formControl,this.formControlName)
    if (this.controlContainer  || this.formControl) {
   
      if (this.formControlName || this.formControl) {
          if(this.formControlName)
            this.control = this.controlContainer.control.get(this.formControlName);
          else{
            console.log("this.formControl",this.formControl)
            this.control = this.formControl;
          }

        if (this.type == "select-searchable") {
          // console.log('select-searchable',this.control.value)
        }
        if (this.type == "text") {
          //    this.control.get(this.formControlName).
          //this.control.setValidators([Validators.maxLength(200)])
        }
        if (this.type == "dimension") {
          // console.log("this.control.value",this.control.value)
          if (this.control.value) {
            let json = JSON.parse(this.control.value);
            this.d_length = json.d_length;
            this.d_width = json.d_width;
            this.dimension = this.Helper.parseNumber(json.d_length * json.d_width).toFixed(2);
            // this.dimension=json.d_length*json.d_width
          }

        }

        if (this.type == "checkbox-multi") {

          let timer = setInterval(() => {
            if (this.options.length > 0) {
              clearInterval(timer)
              this.isOptionSelected()

            }
            else {

            }
          }, 1000)

        }

        if (this.label == "") {
          let lab = this.formControlName.split('_');
          lab = lab.map(v => {
            return v.charAt(0).toUpperCase() + v.slice(1)
          })
          this.label = lab.join(" ");

        }
      }

      else {
        this.control = new FormControl(this.formControlModel)
        if (this.type == "dimension") {
          console.log("this.control.value", this.formControlModel)
          if (this.formControlModel) {
            let json = JSON.parse(this.formControlModel);
            this.d_length = json.d_length;
            this.d_width = json.d_width;

            // this.dimension=json.d_length*json.d_width
            this.dimension = this.Helper.parseNumber(json.d_length * json.d_width).toFixed(2);
          }

        }
        this.control.valueChanges.subscribe(x => {
          this.formControlModelChange.emit(x);
        })

        // console.warn('Missing FormControlName directive from host element of the component');
      }
    } else {
      this.control = new FormControl(this.formControlModel)
      if (this.type == "dimension") {
        // console.log("this.control.value",this.formControlModel)
        if (this.formControlModel) {
          let json = JSON.parse(this.formControlModel);
          this.d_length = json.d_length;
          this.d_width = json.d_width;

          // this.dimension=json.d_length*json.d_width
          this.dimension = this.Helper.parseNumber(json.d_length * json.d_width).toFixed(2);
        }

      }
      this.control.valueChanges.subscribe(x => {
        this.formControlModelChange.emit(x);
      })
      // console.warn('Can\'t find parent FormGroup directive');
    }
  }
  dimension;
  changeVal() {
    console.log("blured")

    // this.control.setValue(this.d_length*this.d_width)
    if (!this.d_length || !this.d_width || this.d_length == null || this.d_width == null) {
      this.control.setValue('')
      this.dimension = ''
    }
    else {
      this.control.markAsTouched()
      this.control.setValue(JSON.stringify({ d_length: this.d_length, d_width: this.d_width, value: this.d_length * this.d_width }))

      // this.dimension=this.d_length*this.d_width
      this.dimension = this.Helper.parseNumber(this.d_length * this.d_width).toFixed(2);


    }
  }

  addEvent(e) {

    if (e.value) {
      try {
        if (this.change)
          this.change.emit(e.value)


        this.control.setValue(this.Helper.convertToDate(e.value, 2));

      }
      catch (err) {

      }
    }
  } 

  checkOptionDisable(option){
    
     return  (this.optionDisable.observers.length>0) ? this.optionDisable.emit(option) :false;
  }

  getOption(option, key) {
    if (key == "key") {
      return typeof option == "string" ? option : this.optionKey ? option[this.optionKey] : option.id;
    }
    else
      return typeof option == "string" ? option : option.title;
  }
  checkboxUpdate(e, val) {
    this.control.markAsTouched()
    if (e.checked)
      this.checkMulti.push(val.id);
    else {
      this.checkMulti.splice(this.checkMulti.indexOf(val.id), 1);
    }
    let join = this.checkMulti.join(",");
    if (join == "") {

    }

    this.control.setValue(join);
    this.change.emit({ all: join, changed: val, checked: e.checked })
  }
  isOptionSelected() {


    if (this.control.value) {
      var Arr = this.control.value.split(",");

      for (let i in this.options) {
        this.options[i].isChecked = Arr.indexOf(this.options[i].id.toString()) !== -1 ? true : false;
        if (this.options[i].isChecked) {
          this.checkMulti.push(this.options[i].id);
          this.change.emit({ all: this.control.value, changed: this.options[i], checked: true })
        }
      }

    }


  }
  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {

  }
  oldValues=[];
  onSearch(search:string,option){
    let available=false;
    if(!search){
      return !available;
    }
    for(let val of this.searchValues){
     if(option[val].toLowerCase().includes(search.toLowerCase())){
      available=true;
      break;
     }

    }
  return  available
    
    

  }
  onChange(e) {
    if(this.type=="select-searchable"){

    }
    console.log("this.control.value",this.control.value);

    this.change.emit(e)
  }

  onChangeTime(ev) {
    if (ev) {
      try {
        this.control.setValue(ev);
      }
      catch (err) {

      }
    }
  }
}
